// LoRaWAN signal of a sensor's last uplink (platform keys link.*, GIOTHUB-189):
// RSSI in dBm with the SNR under it, weak below WEAK_RSSI (the demo's threshold).
import { useT } from "../i18n";

export const WEAK_RSSI = -112;

/** network id of link.network -> display name */
export const netName = (n: unknown) => (n === "lorawan-swisscom" ? "Swisscom LPN" : n ? String(n) : "LoRaWAN");

export function SignalCell({ rssi, snr }: { rssi?: number | null; snr?: number | null }) {
  const t = useT();
  if (rssi == null) return <>—</>;
  return <><span class={rssi < WEAK_RSSI ? "st st-warn" : undefined}>{t.num(rssi)} dBm</span>{snr != null && <><br /><small style="color:var(--muted)">SNR {t.num(snr, 1)}</small></>}</>;
}
